<template>
  <profile-section
    v-if="activeCatalogPages.length > 0"
    :section-title="sectionName"
    class="catalog-profile-section"
  >
    <profile-subsection
      v-for="addon in activeCatalogPages"
      :key="addon.id"
      :disabled="activeSection && activeSection !== sectionName"
      :action-text="actionText(addon)"
      @inactive-action="handleInactiveAction(addon)"
    >
      <template #inactive>
        <p>
          {{ addon.title }}: {{ addon.isAddonActive($store) ? "Active" : "Inactive" }}
        </p>
        <p v-if="hasActivePaidAddon(addon)">
          Expires: {{ formattedExpirationDate(addon) }}
        </p>
      </template>
    </profile-subsection>
    <catalog-remove-modal />
  </profile-section>
</template>

<script>
import { format } from 'date-fns';

import CatalogRemoveModal from '@components/catalog/remove-modal.vue';
import ProfileSection from '@components/profile/section';
import ProfileSubsection from '@components/profile/subsection';

import CatalogPage from '@/classes/catalog-page';

export default {
  components: { CatalogRemoveModal, ProfileSection, ProfileSubsection },
  props: {
    activeSection: {
      type: String,
    },
    user: {
      type: Object,
    },
  },
  computed: {
    activeCatalogPages() {
      const addonPOIds = this.$store.getters['purchaseOrders/addon']
        .map(po => po.id);
      const addonPRs = this.$store.getters['purchaseReceipts/all']
        .filter(pr => pr.active && addonPOIds.includes(pr.purchaseOrderId));

      const catalogPages = this.$store.getters['catalog/pageList'];
      let pages = [];
      addonPRs.forEach(pr => {
        // find the page that links to the root addon
        const PO = this.$store.getters['purchaseOrders/get'][pr.purchaseOrderId];
        const page = catalogPages.find(p => p.purchaseOrderId === PO.parentId);
        if (!pages.map(p => p.id).includes(page?.id)) {
          pages.push(page);
        }
      });
      return pages.filter(page => page);
    },
    sectionName() {
      return 'Add-ons';
    },
  },
  methods: {
    actionText(catalogPage) {
      const status = catalogPage.catalogPageStatus(this.$store);
      if (status === CatalogPage.CATALOG_PAGE_STATUSES.TRIAL) {
        return 'Disable';
      }
      if (status === CatalogPage.CATALOG_PAGE_STATUSES.ACTIVE) {
        return 'Extend Access';
      }

      return '';
    },
    formattedExpirationDate(catalogPage) {
      const receipts = catalogPage.activeCatalogPagePurchaseReceipts(this.$store);
      const receipt = receipts.filter(r => r.expiresAt)?.[0];
      return format(receipt.expiresAt, 'MM/dd/yyyy');
    },
    handleInactiveAction(catalogPage) {
      const status = catalogPage.catalogPageStatus(this.$store);
      if (status === CatalogPage.CATALOG_PAGE_STATUSES.TRIAL) {
        this.$modal.show('catalog-remove-modal', { catalogPage });
      } else if (status === CatalogPage.CATALOG_PAGE_STATUSES.ACTIVE) {
        const params = {
          show: true,
          catalogPageId: catalogPage.id,
          activeSection: 'Extensions',
          source: {
            type: 'Profile',
          },
        };

        this.$store.dispatch('ui/toggleCatalogModal', params);
      }
    },
    hasActivePaidAddon(catalogPage) {
      return catalogPage.catalogPageStatus(this.$store) === CatalogPage.CATALOG_PAGE_STATUSES.ACTIVE;
    },
  },
};
</script>
